import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { WarningIcon, InfoCircleIcon, SfCheckmarkCircleFillIcon, ErrorIcon, SfXmarkIcon } from '@ninja/icons/web';
import styles from './Alert3.js';

const severityObject = {
    warning: {
        icon: jsx(WarningIcon, { className: styles.warningIconStyle }),
        style: styles.warningStyle,
    },
    info: {
        icon: jsx(InfoCircleIcon, { className: styles.infoIconStyle }),
        style: styles.infoStyle,
    },
    success: {
        icon: jsx(SfCheckmarkCircleFillIcon, { className: styles.successIconStyle }),
        style: styles.successStyle,
    },
    error: {
        icon: jsx(ErrorIcon, { className: styles.errorIconStyle }),
        style: styles.errorStyle,
    },
};
const Alert = ({ children, isShown, severity, isClosable = false, onClose, iconPosition = 'center', }) => {
    var _a, _b;
    if (!isShown)
        return jsx(Fragment, {});
    return (jsxs("div", { className: styles.alertContainer(iconPosition, (_a = severityObject[severity]) === null || _a === void 0 ? void 0 : _a.style), children: [jsx("div", { className: styles.alertChildrenContainer(iconPosition), children: (_b = severityObject[severity]) === null || _b === void 0 ? void 0 : _b.icon }), children, isClosable && (jsx("div", { className: styles.xContainer, children: jsx(SfXmarkIcon, { "data-testid": "close-icon", onClick: () => onClose === null || onClose === void 0 ? void 0 : onClose(), className: styles.closeIcon }) }))] }));
};

export { Alert };
